import { ConfirmModal } from '../../../components/modal/confirm-modal/ConfirmModal.component';
import { RecordInLedger } from './RecordInLedger';
// import UnsubscribeDailyFee from './UnsubscribeDailyFee';

export function DailyFeeSettings({ isOpen, closeModal }) {
  return (
    <ConfirmModal
      title="Settings"
      isOpen={isOpen}
      closeModal={closeModal}
      secondaryActionText="Close"
      secondaryBtnClasses="secondary"
      description={
        <>
          <RecordInLedger isOpen={isOpen} />
          {/* <UnsubscribeDailyFee isOpen={isOpen} closeModal={closeModal} /> */}
        </>
      }
    />
  );
}
